module.exports = __webpack_public_path__ + "img/uzb.068d90d0.svg";